(() => {
  let disposeIndex;
  function init() {
    disposeIndex?.();
    const index = document.querySelector('.v2-story-index');
    if (!index) return;
    const links = [...index.querySelectorAll('a[href^="#"]')];
    let pending = false;
    function mark() {
      pending = false;
      const edge = index.getBoundingClientRect().bottom + 100;
      const targets = links
        .map(link => document.getElementById(link.hash.slice(1)))
        .filter(Boolean)
        .sort((a, b) => a === b ? 0 : a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1);
      let current = targets[0];
      for (const target of targets) if (target.getBoundingClientRect().top <= edge) current = target;
      for (const link of links) {
        if (current && link.hash === '#' + current.id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      }
    }
    const onScroll = () => {if (!pending) {pending = true; requestAnimationFrame(mark);}};
    document.addEventListener('scroll', onScroll, {passive:true,capture:true});
    window.addEventListener('resize', mark);
    disposeIndex = () => {
      document.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', mark);
    };
    mark();
  }
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-v2-collection-select]') || !event.target.value) return;
    const url = new URL(event.target.value, window.location.origin);
    if (url.origin === window.location.origin && url.pathname.startsWith('/collections/')) window.location.assign(url.href);
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
